import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import { LinkButtonBlue } from "@helloaudio/ui";

function AIContentModal({
  confirmFunction,
  episodeMinutes,
  isShowModal,
  minutesBalance,
  onClickAddMinutes,
  setIsShowModal,
}) {
  const onClickWrapper = (ev) => {
    ev.preventDefault();
    setIsShowModal(false);
    onClickAddMinutes();
  };

  return (
    <>
      <Modal show={isShowModal} onHide={() => setIsShowModal(false)} centered>
        <Modal.Header
          closeButton
          className="tw-font-Montserrat tw-font-semibold tw-grow tw-text-base tw-text-gray-900"
        >
          Heads up!
        </Modal.Header>
        <Modal.Body>
          <p className="tw-mb-2 tw-font-Montserrat tw-font-medium tw-text-center tw-text-sm tw-text-gray-600">
            This will use {episodeMinutes} of your available {minutesBalance} minutes. Continue?
          </p>
          <div className="tw-flex tw-justify-center tw-my-2">
            <LinkButtonBlue
              onClick={onClickWrapper}
              className="tw-p-0 text-btn-primary tw-flex tw-items-center tw-cursor-pointer episode-uploader-text"
            >
              <div className="tw-flex tw-text-base text-btn-primary">Buy more</div>
            </LinkButtonBlue>
          </div>
          <div className="tw-flex tw-justify-center tw-mt-8">
            <Button
              variant="outline-danger"
              className="tw-py-2 tw-px-8 tw-mx-2 tw-font-Montserrat"
              onClick={(e) => {
                e.preventDefault();
                setIsShowModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="tw-py-2 tw-px-8 tw-mx-2 tw-font-Montserrat"
              onClick={(e) => {
                confirmFunction();
                e.preventDefault();
                setIsShowModal(false);
              }}
            >
              Continue
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

AIContentModal.propTypes = {
  confirmFunction: PropTypes.func.isRequired,
  episodeMinutes: PropTypes.number.isRequired,
  isShowModal: PropTypes.bool.isRequired,
  minutesBalance: PropTypes.number.isRequired,
  onClickAddMinutes: PropTypes.func.isRequired,
  setIsShowModal: PropTypes.func.isRequired,
};

export default AIContentModal;
